import { request, getHost } from './utils';

export const getKeyword = () => {
  const options = {
    method: 'get',

    url: `${getHost()}/api/v1/keyword`,

    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
  };

  return request(options);
};
